import { z } from '@harvestiq/zod';
import { AipIds } from '@harvestiq/constants';

export const submitAgWorksLrpEndorsementPdfMsgSchema = z.object({
  orgId: z.string(),
  aipId: z.nativeEnum(AipIds),
  endorsementId: z.string().uuid(),
});

export type SubmitAgWorksLrpEndorsementPdfMsg = z.infer<
  typeof submitAgWorksLrpEndorsementPdfMsgSchema
>;
